import { ImpulseFormShape, ImpulseFormUnit } from "~/tools/impulse-form";
import { isStringDirty } from "~/tools/is-string-dirty";

import { type DashboardTextVariable, dashboardTextVariableSchema } from "../../../common/dashboard-spec";
import type { FormProcessor } from "../_form-processor";

const shapeSchema = dashboardTextVariableSchema.removeCatch().shape;

export type FormState = ImpulseFormShape<{
	value: ImpulseFormUnit<string, ReadonlyArray<string>>;
	readOnly: ImpulseFormUnit<boolean>;
}>;

export const Processor: FormProcessor<FormState, undefined | DashboardTextVariable> = {
	fromSpec: (spec) =>
		ImpulseFormShape({
			value: ImpulseFormUnit(spec?.value ?? "", {
				isInputDirty: isStringDirty,
				schema: shapeSchema.value.removeCatch(),
			}),
			readOnly: ImpulseFormUnit(spec?.constant ?? false),
		}),

	toSpec: ({ value, readOnly }) => ({
		value,
		constant: readOnly,
	}),
};
